import Constant from '@/common/constant/Constant';
import { useState, useEffect } from 'react';
import { MenuItem, TextField, ListSubheader, Tooltip } from '@material-ui/core';
import Utils from '@/common/utils/utils';
import { Button, IconButton } from '@material-ui/core';
import AssigneeUI from '@/component/formManagement/fieldUI/AssigneeFieldUI';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { getUserListByProjectAtom, userAtom, userPermissionToViewKnowledgeAtom } from '@/state/atom/userAtom';
import { canTicketHasPIC, canTicketHasStatus, getAssignList, onSubmitApproveAnonymousQaFromLiveChat } from '@/component/ticketList/handler/TicketListHandler';
import { getProjectMemberList } from '@/component/ticketList/handler/HelpDeskTicketListHandler';
import { isManagerByProjectInuseSelector } from '@/state/selector/projectSelector';

export default function OriginEmailAssignField({
    detailTicket,
    fieldListDefaultData,
    newAssignee,
    setNewAssignee,
    currentAssigneeUserData,
    setCurrentAssigneeUserData,
    isEdited,
    setIsEdited,
    isEditTicket,
    setIsEditTicket,
    isMe,
    setIsMe,
    newAssigneeData,
    setNewAssigneeData,
    isDisableEdit,
    triggerEnableBtnSaveTicket
}) {

    const currentUserDetail = useRecoilValue(userAtom);
    const [assignField, setAssignField] = useState(null);
    let userListRecoilValue = useRecoilValue(getUserListByProjectAtom);
    const [listFieldEdited, setListFieldEdited] = useState([])
    const isGeneralUser = Utils.isGeneralUserWithoutGuest(currentUserDetail);
    const [assignList, setAssignList] = useState([]);

    const [onChangeEdit, setOnChangeEdit] = useState(false)
    const isProjectManager = useRecoilValue(isManagerByProjectInuseSelector);

    async function fetchData() {
        let personInChargeField = fieldListDefaultData.find(field => field.sysField === 'personInCharge');
        if (personInChargeField) {
            let sortUserList = await getProjectMemberList(userListRecoilValue);
            let assignListRes = getAssignList(sortUserList, currentUserDetail);
            setAssignList(assignListRes);
            setAssignField(personInChargeField);
        }
    }

    useEffect(() => {
        fetchData();
    }, [
        fieldListDefaultData,
    ]);

    useEffect(() => {
        const personInCharge = Utils.convertJSONDataToObject(detailTicket?.personInCharge);
        const personInChargeInfo = Utils.convertJSONDataToObject(detailTicket?.personInChargeInfo);
        if (!Utils.isEmptyString(personInCharge) && !Utils.isEmptyObject(personInChargeInfo)) {
            setCurrentAssigneeUserData(personInChargeInfo);
        } else {
            setCurrentAssigneeUserData({}) 
        }
    }, [detailTicket]);

  
  



   const setFlagReset = () => {

   }

   let argsAll = {
        isMe,
        setFlagReset,
        setIsMe,
        isDisableEdit
   }
   if (!assignField) return (<></>)
  
    return (
        <AssigneeUI
            setNewAssignee={setNewAssignee}
            setNewAssigneeData={setNewAssigneeData}
            setIsEdited={setIsEdited}

            setOnChangeEdit={setOnChangeEdit}
            onChangeEdit={onChangeEdit}

            assigneeUserData={currentAssigneeUserData}
            setCurrentAssigneeUserData={setCurrentAssigneeUserData}
            ticketDetail={detailTicket}
            isGeneralUser={isGeneralUser}
            isManager={isProjectManager} //isProjectManager
            isDisplayButtonEditTicket={true} // isDisplayButtonEditTicket()
            assignList={assignList}
            isHelpDesk={true}
            setListFieldEdited={setListFieldEdited}
            listFieldEdited={listFieldEdited}
            setIsEditTicket={setIsEditTicket}
            data={assignField}
            name={assignField.id}
            isShowIconCopyFieldId={false}
            {...argsAll}
        />
    );
}
